<template>
  <v-main
    min-height="100vh"
    height="100vh"
  >
    <RouterView />
  </v-main>
</template>
